export default {
  fetched: false,
  list: {},
  attributes: {},
  categories: {},
}
